import {HotMatchReducer, ReducerFromState} from "../../../@types/reducers";

export const isLoading = (state: ReducerFromState<HotMatchReducer>): boolean => state.hotMatch.loading;